import { render, staticRenderFns } from "./DownloadPortal.vue?vue&type=template&id=90688be6&scoped=true"
import script from "./DownloadPortal.vue?vue&type=script&lang=js"
export * from "./DownloadPortal.vue?vue&type=script&lang=js"
import style0 from "./DownloadPortal.vue?vue&type=style&index=0&id=90688be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90688be6",
  null
  
)

export default component.exports